export const setPreviewProductVideo = (payload) => ({
  type: "ADD_PREVIEW_PRODUCT_VIDEO",
  payload,
});
